
















































































































































import Vue from 'vue';
import { Component, Prop, Watch, Model } from 'vue-property-decorator';
import { PublicAccount, NetworkType, TransferTransaction } from 'nem2-sdk';
import Scanner from '@/components/scanner/Scanner.vue';
import NoScanner from '@/components/scanner/NoScanner.vue';
import DialogWithCloseButton from '@/components/scanner/DialogWithCloseButton.vue';
import DialogMobile from '@/components/scanner/DialogMobile.vue';
import FrameBox from '@/components/scanner/FrameBox.vue';
import FlatButtonWithIcon from '@/components/FlatButtonWithIcon.vue'; // @ is an alias to /src
import baseAPI from '@/api/horizon-iium-luxtag/index';
@Component({
  components: {
    Scanner,
    NoScanner,
    DialogMobile,
    DialogWithCloseButton,
    FrameBox,
    FlatButtonWithIcon,
  },
})
export default class Verifier extends Vue {
    @Prop({ default: false }) public open!: boolean;
    @Prop() public signers!: string[];

    // show: indicator to show verifier dialog
    public show = this.open;
    public fake = false;
    public verified = false;
    public error = '';
    public errorTimeout = 6000;
    public snackError = false;

    // view: indicator to change the content
    public view = 'illustration';

    // showMobileScanner: indicator to show mobile scanner dialog
    public showMobileScanner = false;

    public scanner = true;
    public isCameraShow = true;
    public cameraPaused = false;
    public mobileCameraHeight = 680;
    public mobileCameraWidth = 480;
    public isMobile = false;
    public illustrationCustomStyle = {
      height: '0px',
    };

    @Watch('open')
    public onOpenChange(val: boolean) {
      this.show = val;
      if (val) {
        // every time it's open it will always open illustration
        this.view = 'illustration';
      }
    }

    @Watch('show')
    public onShowChange(val: boolean) {
      if (!val) {
        // if it close then
        // emit to parent component to change the prop
        this.$emit('update:open', false);
        this.scanner = true;
      }
    }

    public changeView(view: string) {
      this.view = view;
      if (this.isMobile) {
        this.showMobileScanner = false;
      }
    }

    public showScanner() {
      if (this.isMobile) {
        // show mobile scanner
        this.showMobileScanner = true;
      } else {
        // show desktop scanner
        this.view = 'scanner';
      }
    }

    public async onDecode(decode: string) {
      this.$store.commit('MUTATE_LOADER', true);

      try {
        const res = await baseAPI.verify().verifyCertificate(encodeURIComponent(decode));

        if (res.verifiedByAuthority) {

          // save payload and move to certificate page
          this.$store.commit('MUTATE_PAYLOAD', res.data);
          this.$router.push('/' + res.data.address);

        } else {
          this.fake = true;
          this.error = 'This is a fake diploma!';
          this.snackError = true;
        }
      } catch (err) {
        // console.error(err);
      } finally {
        this.$store.commit('MUTATE_LOADER', false);
      }
    }

    public closeDialogScanner() {
      this.showMobileScanner = false;
    }

    public mounted() {
      const that = this;
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });
      this.$on('fake', () => {
        that.fake = true;
      });
    }

    public onResize() {
      let illustrationHeight;
      this.mobileCameraHeight = window.innerHeight;
      this.mobileCameraWidth = window.innerWidth;

      if (window.innerWidth < this.$vuelux.breakpoint.tablet) {
        // below tablet breakpoint
        illustrationHeight = `${window.innerHeight * 75 / 100}px`;
        this.isMobile = true;
      } else {
        // desktop breakpoint
        illustrationHeight = '555px';
        this.isMobile = false;
      }
      this.illustrationCustomStyle.height = illustrationHeight;
    }

    public navigate(route: string) {
      this.$router.push(route);
    }

    get minHeightScanner(): number {
      if (this.mobileCameraHeight < 480) {
        return this.mobileCameraHeight;
      } else {
        return 480;
      }
    }

    get minWidthScanner(): number {
      if (this.mobileCameraWidth < 360) {
        return this.mobileCameraWidth;
      } else {
        return 360;
      }
    }

    get headerTitle() {
      if (this.view === 'illustration') {
        return this.$t('verify.title_p1');
      } else if (this.view === 'scanner') {
        return this.$t('verify.title_p2');
      } else if (this.view === 'no-scanner') {
        return this.$t('verify.title_p3');
      } else {
        return 'We have not specified the title yet';
      }
    }
}
